







import Vue from 'vue'
import { Component, Prop} from 'vue-property-decorator'

@Component<Intersectional>({})
export default class Intersectional extends Vue {
    @Prop(Function) public onScrollEnd?: () => void

    private observer

    public mounted() {
            this.observer = new IntersectionObserver(entries => {
                this.handleIntersection(entries[0])
            })

            this.observer.observe(this.$refs.trigger)
    }

    public beforeDestroy() {
        if(this.observer) {
            this.observer.disconnect();
        }
    }

    private handleIntersection(entry) {
        if(entry.isIntersecting && this.onScrollEnd) {
            this.onScrollEnd()
        }
    }
}

